module.exports = __webpack_public_path__ + "img/big_ico_center@3x.0adf3657.png";